import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notify } from "common/toastUtil";
import { resetSubmission, fetchAdminThunk } from "slices/userSlice";
import { addAppAdminOrAgentThunk } from "slices/userSlice";
import { getUnassignedAppListThunk } from "slices/userSlice";
import { validateAddUserHost } from "common/validation";
import { getAppListThunk } from "slices/userSlice";
import { addUserHostRegisterThunk } from "slices/userSlice";
import { updateUserHostThunk } from "slices/userSlice";
import { fetchUserList } from "services/userService";
import { getUserListByRoleThunk } from "slices/userSlice";
import { clearError } from "slices/userSlice";
import { isValidDate } from "common/validation";

const AddUserHostModal = ({open,setOpen,type,singleData,setSingleData}) => {
      const [form, setForm] = useState({
    name: "",
    email: "",
    googleID: "",
    social_media_type: "google",
    hcode: "",
    gender: "male",
    app_id: "",
    image: null,
    hobbies: [],
    interests: [],
    religion: "",
    languages: [],
    music_taste: [],
    date_of_birth: "",
    state: "",
    country: "",
    city: "",
    pinCode: "",
    isHost:type=="user" ? false:true
  });
      const [errors, setErrors] = useState({
    name: "",
    email: "",
    googleID: "",
    social_media_type: "google",
    hcode: "",
    gender: "male",
    app_id: "",
    image: null,
    hobbies: [],
    interests: [],
    religion: "",
    languages: [],
    music_taste: [],
    date_of_birth: "",
    state: "",
    country: "",
    city: "",
    pinCode: "",
    
  });
console.log("typetype",type,singleData)
  const dispatch = useDispatch();
  const { status, error, data, unAssignedApp,appList,data1 } = useSelector(
    (state) => state.users
  );

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
      const updated = { ...form, [name]: value };
    if (type === "file") {
      setForm({ ...form, image: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
     try {
  const fieldError = validateAddUserHost(updated) || {};
  setErrors({ ...errors, [name]: fieldError[name] ?? "" });
} catch (err) {
  console.error("Validation error:", err);
}

  };

  const handleMultiSelect = (name, value) => {
    setForm((prev) => {
      const values = prev[name].includes(value)
        ? prev[name].filter((v) => v !== value)
        : [...prev[name], value];
      return { ...prev, [name]: values };
    });
  };

  const handleSubmit = () => {
     const validationErrors = validateAddUserHost(form);
         setErrors(validationErrors);
        const isValid = Object.values(validationErrors).every((x) => x === "")
        if(isValid){
             const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => formData.append(key, v));
      } else if (value !== null) {
        formData.append(key, value);
      }
    });
            if(form?.type=="Edit" && form?.id){
dispatch(updateUserHostThunk({id:form?.id,formData}))
            }else{
    dispatch(addUserHostRegisterThunk(formData));

            }
   
        }

  };
const hasFetched = useRef(false);

useEffect(() => {
  if (status === "succeeded" && data1?.status === 201 && !hasFetched.current) {
    hasFetched.current = true; // prevent repeated fetch
    notify("success", data?.message);
    setOpen(false);
    setForm({
      name: "",
      email: "",
      googleID: "",
      social_media_type: "google",
      hcode: "",
      gender: "male",
      app_id: "",
      image: null,
      hobbies: [],
      interests: [],
      religion: "",
      languages: [],
      music_taste: [],
      date_of_birth: "",
      state: "",
      country: "",
      city: "",
      pinCode: "",
    });
    dispatch(resetSubmission());
    dispatch(getUserListByRoleThunk());
  }

  if (error) notify("error", error);
}, [status, error]);


  useEffect(() => {
    dispatch(getAppListThunk());
  }, []);
  useEffect(() => {
  if (open) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, [open]);
useEffect(()=>{
if(singleData?.email){
    setForm({
        ...singleData,
        id:singleData?._id,
        type:"Edit",
        image:null
    })
}
},[singleData])
  return (
  open && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
    <div className="bg-white rounded-xl w-full max-w-2xl mx-4 my-8 max-h-[90vh] overflow-y-auto p-6">
          <h2 className="text-xl font-bold mb-4">{type=="user" ? "User Registeration" : "Host Registeration"}</h2>

          {/* Fields */}
          {[
            "name",
            "email",
            // "googleID",
            // "hcode",
            "religion",
            "date_of_birth",
            "state",
            "country",
            "city",
            "pinCode",
          ].map((field) => (
            <div key={field} className="mb-3">
              <label className="block mb-1 capitalize">{field.replace("_", " ")}</label>
              <input
                name={field}
                type={field === "password" ? "password" : field==="date_of_birth"? "date" : "text"}
                value={  field === "date_of_birth"
    ? isValidDate(form.date_of_birth)
      ? new Date(form.date_of_birth).toISOString().slice(0, 10)
      : ""
    : form[field] || ""}
              disabled={field === "email" && form?.type === "Edit"}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />
                {
                errors[field] && (
                <p className="text-red-500 text-sm mt-1">{errors[field]}</p>)
              }
            </div>
          ))}

          {/* Gender */}
          <div className="mb-3">
            <label className="block mb-1">Gender</label>
            <select name="gender" value={form.gender} onChange={handleChange} className="w-full border px-3 py-2 rounded">
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* App ID */}
         {type=="user" && <div className="mb-3">
            <label className="block mb-1">App ID</label>
            <select
              name="app_id"
              value={form.app_id}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            >
              <option value="">Select App</option>
              {appList?.map((item, i) => (
                <option key={i} value={item?.app_id}>
                  {item?.app_id} - {item?.app_name}
                </option>
              ))}
            </select>
                {
                errors.app_id && (
                <p className="text-red-500 text-sm mt-1">{errors.app_id}</p>)
              }
          </div>
}
          {/* Multi-select checkboxes */}
          {[
            { label: "Hobbies", name: "hobbies", options: ["reading", "cycling", "music"] },
            { label: "Interests", name: "interests", options: ["Technology", "Art", "Sports"] },
            { label: "Languages", name: "languages", options: ["HINDI", "ENGLISH", "FRENCH"] },
            { label: "Music Taste", name: "music_taste", options: ["LIGHT", "PEACE", "ROCK"] },
          ].map(({ label, name, options }) => (
            <div key={name} className="mb-3">
              <label className="block mb-1">{label}</label>
              <div className="flex flex-wrap gap-2">
                {options.map((option) => (
                  <label key={option} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={form[name].includes(option)}
                      onChange={() => handleMultiSelect(name, option)}
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}

          {/* File Upload */}
          <div className="mb-3">
            <label className="block mb-1">Upload Image</label>
            <input
              name="image"
              type="file"
              accept="image/*"
              onChange={handleChange}
              className="w-full"
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-4 mt-4">
            <button
              onClick={() => setOpen(false)}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    )
  );
}
export default AddUserHostModal
